import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import StatsBar from "./components/StatsBar";
import DashboardPreview from "./components/DashboardPreview";
import OnboardingFlow from "./components/OnboardingFlow";
import HowItWorks from "./components/HowItWorks";
import WhatYouGet from "./components/WhatYouGet";
import WhyConvert from "./components/WhyConvert";
import ServiceArea from "./components/ServiceArea";
import Pricing from "./components/Pricing";
import Testimonials from "./components/Testimonials";
import RelatedArticles from "./components/RelatedArticles";
import FAQ from "./components/FAQ";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import LeadForm from "./components/LeadForm";
import StickyMobileCTA from "./components/StickyMobileCTA";

export default function Home() {
  const [formOpen, setFormOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar onRequestLeads={() => setFormOpen(true)} />
      <main>
        <Hero onRequestLeads={() => setFormOpen(true)} />
        <StatsBar />
        <DashboardPreview />
        <OnboardingFlow />
        <HowItWorks />
        <WhatYouGet />
        <WhyConvert />
        <ServiceArea onRequestLeads={() => setFormOpen(true)} />
        <Pricing onRequestLeads={() => setFormOpen(true)} />
        <Testimonials />
        <RelatedArticles />
        <FAQ />
        <FinalCTA onRequestLeads={() => setFormOpen(true)} />
      </main>
      <Footer />
      <LeadForm isOpen={formOpen} onClose={() => setFormOpen(false)} />
      <StickyMobileCTA onRequestLeads={() => setFormOpen(true)} />
    </div>
  );
}
